/**
 * Situational Edge Tags for Sharp Edge AI Playbook
 */

export const SITUATIONAL_TAGS = {
  FAT: {
    code: "FAT",
    name: "Fatigue Factor",
    description: "Rest, schedule density, and extra-inning/OT tax",
    color: "orange"
  },
  TRAV: {
    code: "TRAV",
    name: "Travel Burden",
    description: "Time-zones, altitude, and travel logistics",
    color: "blue"
  },
  PSY: {
    code: "PSY",
    name: "Psychological Edge",
    description: "Motivation, revenge, letdowns, and pressure",
    color: "purple"
  },
  STK: {
    code: "STK",
    name: "Stakes & Context",
    description: "Season standings, blowout rebounds, and desperation",
    color: "red"
  },
  ENV: {
    code: "ENV",
    name: "Environmental",
    description: "Weather, officials, and stadium specifics",
    color: "green"
  },
  PER: {
    code: "PER",
    name: "Personnel/Roster",
    description: "Injuries, load management, and coaching changes",
    color: "yellow"
  },
  MKT: {
    code: "MKT",
    name: "Market Mispricing",
    description: "Market mispriced lines, inflated lines, unadjusted lines, steam lines",
    color: "cyan"
  }
};

export const TAG_COLORS = {
  FAT: "bg-orange-500/20 text-orange-400 border-orange-500/30",
  TRAV: "bg-blue-500/20 text-blue-400 border-blue-500/30",
  PSY: "bg-purple-500/20 text-purple-400 border-purple-500/30",
  STK: "bg-red-500/20 text-red-400 border-red-500/30",
  ENV: "bg-green-500/20 text-green-400 border-green-500/30",
  PER: "bg-yellow-500/20 text-yellow-400 border-yellow-500/30",
  MKT: "bg-cyan-500/20 text-cyan-400 border-cyan-500/30"
};

export const TAG_LIST = Object.values(SITUATIONAL_TAGS);

export default SITUATIONAL_TAGS;
